import React from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap'
import Loader from 'react-loader-spinner'

let LoadingModal = ({modal}) =>
    <Modal isOpen={modal}>        
        <ModalBody style={{margin:'10px 0 10px 0'}}>
            <Loader type="TailSpin" width={60} height={60} />
            <br />
            <h5>Loading...</h5>
        </ModalBody>
    </Modal>

export default LoadingModal



// WEBPACK FOOTER //
// ./src/components/ui/LoadingModal.js